module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Paypal-8ce1c3c7eb96a76806ae9e9f957676ea.svg";